

















































import { Component, Watch, Vue } from 'vue-property-decorator'
import { hasOwnProp, isArray } from '@/utils'
import { Load, cloner } from '@/units'
import Obs from '@/form'
import CForm from '@/components/Form/index.vue'
import './style.less'

@Component({
  components: {
    CForm
  }
})

export default class Configuration extends Vue {
  constructor () {
    super()

    console.info('📦 [Configuration] componentDidMount....')
  }

  private taps: any = [
    { param: 'cameras', label: 'camera' },
    { param: 'businesses', label: 'business' },
    { param: 'branches', label: 'branch' },
    { param: 'cities', label: 'city' },
    { param: 'areas', label: 'area' },
  ]
  private model: any = {}
  private mode: any = new Obs({
    open: false,
    type: 'add',
    data: undefined
  })
  
  // __CREATED
  public async created () {
    Load(this, true)

    await this.$store.dispatch('APP.COG/pull')
    Load(this, false)
  }

  // __METHODS
  private config () {
    const config: any = require('./config.json')
    this.model = cloner(config)
  }

  private onOpen (): void {
    this.config()
    this.mode.set({ open: true, type: 'add', data: this.def.field })
  }

  private onClose (): void {
    this.config()
    this.mode.reset()
  }

  private onEvents (val: any): void {
    if (val.type === 'remove') {
      this.onRemove(val.data)
    } else {
      this.config()
      this.model.field[this.paramName] = val.data
      this.mode.set({ open: true, type: val.type, data: val.data })
    }
  }

  /**
   * For customForm submit|save
   */
  private async onTouch (val: any) {
    Load(this, true)

    const is: any = (s: string): boolean => (s === this.mode.type)
    const handle: any = {
      method  : is('add') ? 'POST' : 'PATCH',
      body    : val,
      mutation: this.paramName
    }

    switch (this.paramName) {
      case 'cameras':
        handle.get = '/camera'

        const x: any = this.db.branches.find((h: any) => h.id === val.branch_id)
          handle.body.business_id = x.business_id
          handle.body.city_id = x.city_id
        break;

      case 'businesses':
        handle.get = '/business'
        break;

      case 'branches':
        handle.get = '/branch'
        break;

      case 'cities':
        handle.get = '/city'
        break;

      case 'areas':
        handle.get = '/area'
        break;
    }

    handle.path = `${handle.get}/${ is('add') ? 'create' : val.id}`

    const res = await this.$store.dispatch('APP.COG/allFetch', handle)
    if (res) this.onClose()
    else alert('Something went wrong!!')

    Load(this, false)
  }

  private async onRemove (param: any) {
    Load(this, true)
    const handle: any = {
      method  : 'POST',
      body    : { id: param.id, status: 0 },
      mutation: this.paramName
    }

    switch (this.paramName) {
      case 'cameras':
        handle.get = '/camera'
        break;

      case 'businesses':
        handle.get = '/business'
        break;

      case 'branches':
        handle.get = '/branch'
        break;

      case 'cities':
        handle.get = '/city'
        break;

      case 'areas':
        handle.get = '/area'
        break;
    }

    handle.path = `${handle.get}/set/active`

    const res = await this.$store.dispatch('APP.COG/allFetch', handle)
    if (!res) alert('Something went wrong!!')

    Load(this, false)
  }

  private async switchFetch () {
    Load(this, true)

    let s: string = '/camera'
    switch (this.paramName) {
      case 'cameras': s = '/camera'; break;
      case 'businesses': s = '/business'; break;
      case 'branches': s = '/branch'; break;
      case 'cities': s = '/city'; break;
      case 'areas': s = '/area'; break;
    }

    await this.$store.dispatch('APP.COG/addOn', {
      path: s,
      state: this.paramName
    })
    Load(this, false)
  }

  // __COMPUTED
  private get paramName (): string {
    const { name }: any = this.$route.params
    return name || ''
  }

  private get modalTitle (): string {
    const h: any = this.taps.find((x: any) => x.param === this.paramName)
    return h.label || this.paramName
  }

  /**
   * Switch Dynamic Components when tap change
   * 
   * @return {component}
   */
  private get currentTabComponent (): any {
    if (this.paramName === 'cameras') {
      var component: any = () => import('./helpers/Cameras.vue')
    } else {
      var component: any = () => import('./helpers/Other.vue')
    }
    return component
  }

  /**
   * Dynamic Modal Fields.
   * 
   * @return {Array}
   */
  private get def (): any {
    const field: any = this.model.field[this.paramName]
    const form: any  = this.model.form[this.paramName]
    
    // Pull data for radioType.
    for (const elm of form) {
      if (elm.data && hasOwnProp(this.db, elm.data)) {
        elm.data = this.db[elm.data].remove('isActive', 0)
      }
    }

    return { form, field }
  }

  private get db (): any {
    const db: any = this.$store.getters['APP.COG/all']
    return {
      ...db,
      active: [
        { id: 1, name: this.$t('enabled') },
        { id: 0, name: this.$t('disabled') }
      ]
    }
  }

  // __WATCH
  @Watch('$route') watchRoute () {
    this.mode.reset()
    this.switchFetch()
  }
}
